import { Theme } from '@mui/material/styles'

const muiSwitch = (theme: Theme) => {
  return {
    variants: [
      {
        props: { size: 'smallest' },
        style: {
          height: '1rem',
          width: '1.875rem',
          '& .MuiSwitch-switchBase ': {
            padding: '0.5rem',
            '&.Mui-checked': {
              transform: 'translateX(0.875rem)'
            }
          },
          '& .MuiSwitch-thumb': {
            height: '0.625rem',
            width: '0.625rem',
            margin: '0.5rem'
          }
        }
      }
    ],
    styleOverrides: {
      root: {
        width: '3rem',
        height: '1.75rem',
        padding: 0,
        marginLeft: '0.5rem',
        marginRight: '0.5rem',
        '& .MuiSwitch-switchBase': {
          '&.Mui-checked': {
            transform: 'translateX(2rem)',
            color: theme.palette.primary.main
          }
        }
      },

      switchBase: {
        height: '0.125rem',
        width: '0.125rem',
        padding: '0.875rem',
        '&.Mui-checked + .MuiSwitch-track': {
          opacity: 1,
          background: theme.palette.success.main
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 1,
          background: theme.colors.stroke
        }
      },
      track: {
        borderRadius: '2rem',
        opacity: 1,
        background: theme.colors.disabled
      },
      thumb: {
        flexShrink: 0,
        width: '1.25rem',
        height: '1.25rem',
        margin: '0.875rem',
        background: theme.palette.background.default
      },
      sizeSmall: {
        height: '1.375rem',
        width: '2.625rem',
        '& .MuiSwitch-thumb': {
          width: '0.875rem',
          height: '0.875rem'
        },
        '& .MuiSwitch-switchBase': {
          height: '1.375rem',
          width: '1.375rem',
          '&.Mui-checked': {
            transform: 'translateX(1.2rem)'
          }
        }
      }
    }
  }
}
export default muiSwitch
